export const selectCurrentUser = (state) => state.auth.currentUser;
export const selectCurrentPartner = (state) => state.auth.currentPartner;
export const selectProfiles = (state) => state.auth.profiles;
export const selectPartners = (state) => state.auth.partners;
export const selectIntegrationId = (state) => state.auth.integrationId;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
